import React, { Component } from 'react';
import { Field, reduxForm, propTypes as formPropTypes } from 'redux-form';
import ReduxFormInput from './common/forms/ReduxFormInput';

const strip = value => value && value.replace(/\s/g, '');

class AffiliateSignUpForm extends Component {
  static propTypes = {
    ...formPropTypes,
  };

  state = {
    acceptedTerms: false,
  };

  handleToggleTerms = () => {
    this.setState(state => ({ acceptedTerms: !state.acceptedTerms }));
  };

  render() {
    const { error, initialValues, submitting, handleSubmit, onSubmit } = this.props;
    const { acceptedTerms } = this.state;

    return (
      <div className="subscribe__form" width="350">
        <div className="credit-card-form">
          <form onSubmit={handleSubmit(onSubmit)}>
            <h3>Enter your information</h3>
            <div className="credit-card-form__card-details">
              <Field name="firstName" component={ReduxFormInput} label="First Name" required>
                <input type="text" />
              </Field>
              <Field name="lastName" component={ReduxFormInput} label="Last Name" required>
                <input type="text" />
              </Field>
            </div>
            <Field
              name="email"
              component={ReduxFormInput}
              label="Email Address"
              disabled={!!initialValues.email}
              subtext={
                !!initialValues.email
                  ? 'We need to use the email associated with your Tathata membership for tax-tracking. To change this email, change the email associated with your Tathata membership.'
                  : undefined
              }
              required
            >
              <input type="text" disabled={!!initialValues.email} />
            </Field>
            <div className="input-scaffold">
              <span className="input-label">
                US Taxable? <span className="input-required">REQUIRED</span>
              </span>
              <span className="input-subtext">
                If Yes, you will be asked to complete a W-9. If No, you will be asked to complete a W-8BEN form.
              </span>
              <label className="toggle-label">
                <Field name="usTaxable" component="input" type="radio" value="true" />
                Yes
              </label>
              <label className="toggle-label">
                <Field name="usTaxable" component="input" type="radio" value="false" />
                No
              </label>
            </div>
            <Field
              name="coupon"
              component={ReduxFormInput}
              normalize={strip}
              label="Affiliate Code"
              subtext="This will be used as a coupon code for members you refer to Tathata."
              required
            >
              <input type="text" />
            </Field>
            <div className="input-scaffold">
              <label className="toggle-label">
                <input type="checkbox" checked={acceptedTerms} onChange={this.handleToggleTerms} />I agree to the terms
                and conditions of the{' '}
                <a href="https://www.tathatagolf.com/affiliate-agreement/" target="_blank">
                  Affiliate Agreement
                </a>
              </label>
            </div>
            {error && <div className="input-validation">{error}</div>}
            <div>
              <button type="submit" className="button button--large" disabled={submitting || !acceptedTerms}>
                Become An Affiliate
              </button>
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const validate = values => {
  const errors = {};
  if (!values.firstName || !values.firstName.trim()) {
    errors.firstName = 'First name is required.';
  }
  if (!values.lastName || !values.lastName.trim()) {
    errors.lastName = 'Last name is required.';
  }
  if (!values.email || !values.email.trim()) {
    errors.email = 'Email is required.';
  }
  if (!values.coupon || !values.coupon.trim()) {
    errors.coupon = 'Coupon is required.';
  }
  return errors;
};

export default reduxForm({
  form: 'AffiliateSignUpForm',
  validate,
})(AffiliateSignUpForm);



// WEBPACK FOOTER //
// ./src/AffiliateSignUpForm.js